import common from '@/services/mainService/common/index';
import mainPage from '@/services/mainService/mainPage/index';
import leverages from '@/services/mainService/leverages/index';
import whitelists from '@/services/mainService/whitelists/index';
import transfers from '@/services/mainService/transfers/index';
import spot from '@/services/mainService/spot/index';
export default Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, common), mainPage), leverages), whitelists), transfers), spot);
